import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user card shadow-sm bg-white mb-5" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex flex-row align-items-center justify-content-between" }
const _hoisted_4 = { class: "d-flex flex-row align-items-center" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "text-start ms-3" }
const _hoisted_7 = { class: "card-title fs-5" }
const _hoisted_8 = { class: "card-subtitle text-black-50 fs-6" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-1\"><button type=\"button\" class=\"report-user btn py-0 px-1\"><em class=\"bi bi-exclamation-triangle link-warning fs-2\"></em></button><button type=\"button\" class=\"geolocate btn py-0 px-1\"><em class=\"bi bi-geo-alt fs-2 text-primary\"></em></button></div>", 1)
const _hoisted_10 = { class: "bio text-justify lh-sm pt-4" }
const _hoisted_11 = { class: "d-flex flex-column text-start" }
const _hoisted_12 = { class: "address d-flex mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-geo-alt" }, null, -1)
const _hoisted_14 = { class: "align-self-center ps-2 m-0" }
const _hoisted_15 = { class: "email d-flex mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-envelope" }, null, -1)
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "contact d-flex mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-telephone" }, null, -1)
const _hoisted_20 = { class: "align-self-center ps-2 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: _ctx.setURL(_ctx.user.avatar),
              alt: _ctx.user.name,
              class: "avatar rounded-circle object-fit-cover text-white bg-dark"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.user.name), 1),
            _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.user.address), 1)
          ])
        ]),
        _hoisted_9
      ]),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.user.bio), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.user.address), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("a", {
            href: `mailto:${_ctx.user.email}`,
            class: "align-self-center text-black ps-2 m-0"
          }, _toDisplayString(_ctx.user.email), 9, _hoisted_17)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.user.contact), 1)
        ])
      ])
    ])
  ]))
}